<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "bold";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M10.6364 6.63637C10.9878 6.2849 10.9878 5.71505 10.6364 5.36358C10.2849 5.01211 9.71505 5.01211 9.36358 5.36358L3.36358 11.3636C3.01211 11.7151 3.01211 12.2849 3.36358 12.6364L9.36358 18.6364C9.71505 18.9878 10.2849 18.9878 10.6364 18.6364C10.9878 18.2849 10.9878 17.7151 10.6364 17.3636L6.17277 12.9H20C20.497 12.9 20.9 12.497 20.9 12C20.9 11.5029 20.497 11.1 20 11.1H6.17277L10.6364 6.63637Z"
    />
    <path
      v-else-if="weight === 'bold'"
      d="M11.0607 7.06066C11.6464 6.47487 11.6464 5.52513 11.0607 4.93934C10.4749 4.35355 9.52513 4.35355 8.93934 4.93934L2.93934 10.9393C2.35355 11.5251 2.35355 12.4749 2.93934 13.0607L8.93934 19.0607C9.52513 19.6464 10.4749 19.6464 11.0607 19.0607C11.6464 18.4749 11.6464 17.5251 11.0607 16.9393L7.62132 13.5H20C20.8284 13.5 21.5 12.8284 21.5 12C21.5 11.1716 20.8284 10.5 20 10.5H7.62132L11.0607 7.06066Z"
    />
  </svg>
</template>
